// extracted by mini-css-extract-plugin
export var bodyRow = "_gz-d";
export var cardColumns = "_gz-e";
export var ellipsesOverflow = "_gz-2";
export var flatBottomCorners = "_gz-3";
export var flatTopCorners = "_gz-4";
export var headerActionsDropdown = "_gz-f";
export var headerBottomRow = "_gz-c";
export var headerTopRow = "_gz-b";
export var orderDetailsWrapper = "_gz-0";
export var orderInfoContainer = "_gz-1";
export var productDetails = "_gz-9";
export var productImage = "_gz-5";
export var responsiveTable = "_gz-8";
export var shipmentContainer = "_gz-a";
export var tableBottomLeft = "_gz-6";
export var tableBottomRight = "_gz-7";